module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow.red-9356fd20cb8f5db3af6c2bc1eb1b286d.svg";